import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { Aplicacao } from '../_models/usuario/aplicacao';
import { Observable } from 'rxjs';
import { AplicacaoResponse } from '../_models/response/aplicacaoResponse';
import { Empresa } from '../_models/usuario/empresa';

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

@Injectable({ providedIn: 'root' })
export class AplicacaoService {
  constructor(private http: HttpClient) { }

  getAplicaoPorEmpresa(empresa: Empresa): Observable<Aplicacao[]> {
    return this.http.post<Aplicacao[]>(`${environment.authorizedUrls.bsCobrancaUrl}/aplicacao/listarAplicacaoPorEmpresa`, {
      empresa
    });
  }

  inserir(aplicacao: Aplicacao): Observable<AplicacaoResponse> {
    return this.http.post<AplicacaoResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/aplicacao/incluir`, {
      aplicacao
    });
  }

  atualizar(aplicacao: Aplicacao): Observable<AplicacaoResponse> {
     return this.http.post<AplicacaoResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/aplicacao/atualizar`, {
      aplicacao
    });
  }

  deletar(aplicacao: Aplicacao): Observable<AplicacaoResponse> {
    return this.http.post<AplicacaoResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/aplicacao/excluir`,  {
      aplicacao
    });
  }

}
